// import {
//   HttpEvent,
//   HttpHandler,
//   HttpInterceptor,
//   HttpRequest,
// } from '@angular/common/http';
// import { Injectable } from '@angular/core';
// import { from, Observable } from 'rxjs';
// import { delay, dematerialize, materialize, switchMap } from 'rxjs/operators';
// import { USER_TOKEN_KEY } from '@boxx/login-core';
// import { LocalStorageNativeService } from 'src/services/NativeLocalStorage.service';

// @Injectable({ providedIn: 'root' })
// export class BoxxJwtInterceptor implements HttpInterceptor {
//   constructor(private localStge: LocalStorageNativeService) {}

//   intercept(
//     request: HttpRequest<any>,
//     next: HttpHandler
//   ): Observable<HttpEvent<any>> {
//     return from(this.localStge.getItem(USER_TOKEN_KEY)).pipe(
//       switchMap((token) => {
//         if (
//           token &&
//           request.url.indexOf('auth/login') === -1 &&
//           request.url.indexOf('/brand/') === -1 &&
//           request.url.indexOf('/mybusinessaccountmanagement') === -1 &&
//           request.url.indexOf('/graph.facebook.com') === -1 &&
//           request.url.indexOf('/Oauthwid/update') === -1  &&
//           request.url.indexOf('/userinfo') === -1
//         ) {
//           request = request.clone({
//             headers: request.headers.set('Authorization', `Bearer ${token}`),
//           });
//         }

//         if (
//           !request.headers.has('Content-Type') &&
//           request.url.indexOf('upload_update_images') === -1 &&
//           request.url.indexOf('/wizard/upload_image') === -1 &&
//           request.url.indexOf('/gmb/add_img') === -1
//         ) {

//           if (!request.url.includes("json/v2/wizard/create_user")) {
//             request = request.clone({
//               headers: request.headers.set(
//                 'Content-Type',
//                 'application/x-www-form-urlencoded'
//               ),
//             });
//           }

//         }

//         if (
//           request.url.includes("/gmb/add_img")
//         ) {
//           console.log('3');
//           request = request.clone({
//             headers: request.headers.set(
//               'Content-Type',
//               'application/x-www-form-urlencoded'
//             ),
//           });
//         }

//         return next.handle(request);
//       }),
//       materialize(),
//       delay(800),
//       dematerialize()
//     );
//   }
// }

import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { from, Observable, forkJoin } from 'rxjs';
import { switchMap, materialize, delay, dematerialize } from 'rxjs/operators';
import { USER_LANGUAGE, USER_TOKEN_KEY } from '@boxx/login-core';
import { LocalStorageNativeService } from 'src/services/NativeLocalStorage.service';

@Injectable({ providedIn: 'root' })
export class BoxxJwtInterceptor implements HttpInterceptor {
  constructor(private localStge: LocalStorageNativeService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Obtener el token y el idioma seleccionado de forma paralela
    const token$ = from(this.localStge.getItem(USER_TOKEN_KEY));
    const selectedLanguage$ = from(this.localStge.getItem(USER_LANGUAGE));

    return forkJoin([token$, selectedLanguage$]).pipe(
      switchMap(([token, selectedLanguage]) => {
        // Agregar el token al encabezado si corresponde
        if (
          token &&
          request.url.indexOf('auth/login') === -1 &&
          request.url.indexOf('/brand/') === -1 &&
          request.url.indexOf('/mybusinessaccountmanagement') === -1 &&
          request.url.indexOf('/graph.facebook.com') === -1 &&
          request.url.indexOf('/Oauthwid/update') === -1 &&
          request.url.indexOf('/userinfo') === -1
        ) {
          request = request.clone({
            headers: request.headers.set('Authorization', `Bearer ${token}`),
          });
        }

        // Agregar el encabezado Content-Type si corresponde
        if (
          !request.headers.has('Content-Type') &&
          request.url.indexOf('upload_update_images') === -1 &&
          request.url.indexOf('/wizard/upload_image') === -1 &&
          request.url.indexOf('/gmb/add_img') === -1
        ) {
          if (!request.url.includes('json/v2/wizard/create_user')) {
            request = request.clone({
              headers: request.headers.set(
                'Content-Type',
                'application/x-www-form-urlencoded'
              ),
            });
          }
        }

        // Agregar encabezado específico para /gmb/add_img
        if (request.url.includes('/gmb/add_img')) {
          request = request.clone({
            headers: request.headers.set(
              'Content-Type',
              'application/x-www-form-urlencoded'
            ),
          });
        }

        // Agregar el encabezado Accept-Language si existe la variable selectedLanguage
        if (selectedLanguage) {
          request = request.clone({
            headers: request.headers.set('Accept-Language', selectedLanguage),
          });
        }

        return next.handle(request);
      }),
      materialize(),
      delay(800),
      dematerialize()
    );
  }
}
